import React, { useState, useEffect } from 'react';
import { Star, Check, X, Trash2 } from 'lucide-react';

const ReviewModeration = () => {
  const [reviews, setReviews] = useState([]);
  const [loading, setLoading] = useState(true);
  const [filter, setFilter] = useState('');

  useEffect(() => {
    fetchReviews();
  }, [filter]);

  const fetchReviews = async () => {
    try {
      const token = localStorage.getItem('admin_token');
      let url = `${process.env.REACT_APP_BACKEND_URL}/api/admin/reviews`;
      if (filter === 'pending') url += '?approved=false';
      if (filter === 'approved') url += '?approved=true';
      
      const res = await fetch(url, {
        headers: { 'Authorization': `Bearer ${token}` }
      });
      if (!res.ok) throw new Error('Failed');
      const data = await res.json();
      setReviews(data);
    } catch (err) {
      console.error(err);
    } finally {
      setLoading(false);
    }
  };

  const approveReview = async (reviewId, approved) => {
    try {
      const token = localStorage.getItem('admin_token');
      const res = await fetch(`${process.env.REACT_APP_BACKEND_URL}/api/admin/reviews/${reviewId}/approve?approved=${approved}`, {
        method: 'PUT',
        headers: { 'Authorization': `Bearer ${token}` }
      });
      if (!res.ok) throw new Error('Failed');
      fetchReviews();
    } catch (err) {
      alert('Ошибка: ' + err.message);
    }
  };

  const deleteReview = async (reviewId) => {
    if (!confirm('Удалить отзыв?')) return;
    try {
      const token = localStorage.getItem('admin_token');
      const res = await fetch(`${process.env.REACT_APP_BACKEND_URL}/api/admin/reviews/${reviewId}`, {
        method: 'DELETE',
        headers: { 'Authorization': `Bearer ${token}` }
      });
      if (!res.ok) throw new Error('Failed');
      fetchReviews();
    } catch (err) {
      alert('Ошибка: ' + err.message);
    }
  };

  return (
    <div>
      <div className="mb-6">
        <select
          value={filter}
          onChange={(e) => setFilter(e.target.value)}
          className="w-full md:w-64 px-4 py-3 bg-gray-800/50 border border-gray-700 rounded-lg text-white focus:outline-none focus:ring-2 focus:ring-red-500"
        >
          <option value="">Все отзывы</option>
          <option value="pending">Не одобренные</option>
          <option value="approved">Одобренные</option>
        </select>
      </div>

      <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
        {loading ? (
          <div className="col-span-2 text-center py-8 text-gray-400">Загрузка...</div>
        ) : reviews.length === 0 ? (
          <div className="col-span-2 text-center py-8 text-gray-400">Отзывы не найдены</div>
        ) : (
          reviews.map((review) => (
            <div
              key={review.id}
              className={`bg-gray-800/50 rounded-xl p-6 border ${
                review.approved ? 'border-green-500/30' : 'border-yellow-500/30'
              }`}
            >
              <div className="flex items-start justify-between mb-4">
                <div>
                  <h3 className="text-lg font-bold text-white">{review.name}</h3>
                  <p className="text-sm text-gray-400">{review.email}</p>
                  <div className="flex items-center gap-1 mt-2">
                    {[...Array(5)].map((_, i) => (
                      <Star
                        key={i}
                        className={`w-4 h-4 ${
                          i < review.rating ? 'fill-yellow-400 text-yellow-400' : 'text-gray-600'
                        }`}
                      />
                    ))}
                  </div>
                </div>
                <span className={`px-2 py-1 rounded-full text-xs font-medium ${
                  review.approved
                    ? 'bg-green-500/20 text-green-400'
                    : 'bg-yellow-500/20 text-yellow-400'
                }`}>
                  {review.approved ? 'Одобрен' : 'На модерации'}
                </span>
              </div>
              <p className="text-gray-300 mb-4">{review.comment}</p>
              <div className="text-xs text-gray-500 mb-4">
                {new Date(review.created_at).toLocaleString('ru-RU')}
              </div>
              <div className="flex gap-2">
                {!review.approved && (
                  <button
                    onClick={() => approveReview(review.id, true)}
                    className="flex-1 px-4 py-2 bg-green-500 hover:bg-green-600 text-white rounded-lg transition-colors flex items-center justify-center gap-2"
                  >
                    <Check className="w-4 h-4" />
                    Одобрить
                  </button>
                )}
                {review.approved && (
                  <button
                    onClick={() => approveReview(review.id, false)}
                    className="flex-1 px-4 py-2 bg-yellow-500 hover:bg-yellow-600 text-white rounded-lg transition-colors flex items-center justify-center gap-2"
                  >
                    <X className="w-4 h-4" />
                    Отменить
                  </button>
                )}
                <button
                  onClick={() => deleteReview(review.id)}
                  className="px-4 py-2 bg-red-500 hover:bg-red-600 text-white rounded-lg transition-colors"
                >
                  <Trash2 className="w-4 h-4" />
                </button>
              </div>
            </div>
          ))
        )}
      </div>
    </div>
  );
};

export default ReviewModeration;